import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';

class MaintenanceDialog extends Component {
    constructor(props) {
        super(props);
        let flag = localStorage.getItem("Maintenance");
        let between = localStorage.getItem("Between");
        this.state = {
            maintenance: {
                flag: flag === "true" ? true : false,
                between: between,
            },
        }
    }
    componentDidMount() {
        setInterval(() => {
            let flag = localStorage.getItem("Maintenance");
            let between = localStorage.getItem("Between");
            this.setState({
                maintenance: {
                    flag: flag === "true" ? true : false,
                    between: between,
                }
            });
        }, 1000);
    }
    render() {
        let maintenance = this.state.maintenance ? this.state.maintenance : {flag: false, between: ""};
        return (
            <MaintenanceBg Display={maintenance.flag}>
                <MaintenanceDlg>
                    <MaintenanceTitle>メンテナンス中</MaintenanceTitle>
                    <MaintenanceContents Selectable={maintenance.flag}>
                        ただいまメンテナンス中です<br/>
                        <MaintenanceInfo>
                            期間: {maintenance.between}
                        </MaintenanceInfo>
                        お問い合わせの場合は以下よりご連絡ください
                        <MaintenanceInfo>
                            お問い合わせ先: info.prime@englishcompany.jp
                        </MaintenanceInfo>
                    </MaintenanceContents>
                </MaintenanceDlg>
            </MaintenanceBg>
        )
    }
}
const mapStateToProps = store => {
    return {
        maintenance: store.setting.maintenance,
    }
};

const connectedMaintenanceDialog = connect(mapStateToProps)(MaintenanceDialog);
export { connectedMaintenanceDialog as MaintenanceDialog };

const MaintenanceBg = styled.div `
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: ${props => props.Display ? "block" : "none"};
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 200;
`;
const MaintenanceDlg = styled.div`
    position: absolute;
    min-width: 300px;
    min-height: 400px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`;
const MaintenanceTitle = styled.h3`
    margin: 10px 0;
`;
const MaintenanceContents = styled.article`
    margin: 10px 10px;
    text-align: left;
    ${props => props.Selectable ? css`
    -webkit-touch-callout: text; /* iOS Safari */
    -webkit-user-select: text; /* Safari */
    -khtml-user-select: text; /* Konqueror HTML */
    -moz-user-select: text; /* Firefox */
    -ms-user-select: text; /* Internet Explorer/Edge */
    user-select: text; /* Non-prefixed version, currently supported by Chrome and Opera */
    ` : ``};
`;
const MaintenanceInfo = styled.div`
    margin: 10px 0;
`;